module.exports = __webpack_public_path__ + "static/media/enrolments_menu_blue.f11dd779.svg";